import { Translatable } from '@app/types/translatable.type';

const QuestionTypeDisplayOptions: { [key: string]: Translatable } = {
    'Single line': 'questionType.singleLine',
    'Multi line': 'questionType.multiLine',
    Number: 'questionType.number',
    Date: 'questionType.date',
};

const QuestionTypeDescriptionDisplayOptions: { [key: string]: Translatable } = {
    'For questions that need short responses': 'questionType.singleLineDesc',
    'For questions that need long responses': 'questionType.multiLineDesc',
    'When the answer needs to be a number': 'questionType.numberDesc',
    'When the answer needs to be a date': 'questionType.dateDesc',
};

export { QuestionTypeDisplayOptions, QuestionTypeDescriptionDisplayOptions };
